export const QUOTE_REQUEST_NOT_FOUND_ERROR = 'Quote request not found';

export const SAMPLE_REQUEST_NOT_FOUND_ERROR = 'Sample request not found';
